import React from 'react';
import { Button } from './ui/Button';
import { ArrowRight, CheckCircle2 } from 'lucide-react';
import { motion } from 'framer-motion';
export function Hero() {
  const scrollToContact = () => {
    document.getElementById('contact')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section id="hero" className="relative pt-32 pb-20 lg:pt-48 lg:pb-32 overflow-hidden bg-slate-50" data-id="element-110">
      {/* Background decoration */}
      <div className="absolute top-0 right-0 -translate-y-12 translate-x-1/4 opacity-5" data-id="element-111">
        <svg width="400" height="400" viewBox="0 0 200 200" xmlns="http://www.w3.org/2000/svg" data-id="element-112">
          <path fill="#2563EB" d="M44.7,-76.4C58.9,-69.2,71.8,-59.1,81.6,-46.6C91.4,-34.1,98.1,-19.2,95.8,-4.9C93.5,9.4,82.2,23.1,70.8,34.3C59.4,45.5,47.9,54.2,35.6,61.7C23.3,69.2,10.2,75.5,-1.9,78.8C-14,82.1,-25.1,82.4,-35.6,76.6C-46.1,70.8,-56,58.9,-64.3,46.2C-72.6,33.5,-79.3,20,-80.6,6C-81.9,-8,-77.8,-22.5,-69.3,-34.6C-60.8,-46.7,-47.9,-56.4,-34.6,-64.1C-21.3,-71.8,-7.6,-77.5,5.1,-86.3L17.8,-95.1" transform="translate(100 100)" data-id="element-113" />
        </svg>
      </div>

      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 relative" data-id="element-114">
        <div className="flex flex-col lg:flex-row items-center gap-12 lg:gap-20" data-id="element-115">
          {/* Text Content */}
          <div className="flex-1 text-center lg:text-left" data-id="element-116">
            <motion.div initial={{
            opacity: 0,
            y: 20
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            duration: 0.5
          }} data-id="element-117">
              <div className="inline-flex items-center gap-2 rounded-full bg-blue-50 px-3 py-1 text-sm font-medium text-blue-700 mb-6" data-id="element-118">
                <span className="relative flex h-2 w-2" data-id="element-119">
                  <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-blue-400 opacity-75" data-id="element-120"></span>
                  <span className="relative inline-flex rounded-full h-2 w-2 bg-blue-500" data-id="element-121"></span>
                </span>
                Accepting New Clients
              </div>

              <h1 className="text-4xl font-bold tracking-tight text-slate-900 sm:text-5xl lg:text-6xl mb-6 leading-tight" data-id="element-122">
                Reliable Customer Support That Helps Your{' '}
                <span className="text-blue-600" data-id="element-123">Business Grow</span>
              </h1>

              <p className="text-lg text-slate-600 mb-8 max-w-2xl mx-auto lg:mx-0 leading-relaxed" data-id="element-124">
                AMK Solutions provides professional email, chat, and phone
                support tailored to your business needs. Scale your operations
                without sacrificing quality.
              </p>

              <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-4" data-id="element-125">
                <Button size="lg" onClick={scrollToContact} className="w-full sm:w-auto group" data-id="element-126">
                  Get a Free Consultation
                  <ArrowRight className="ml-2 h-4 w-4 transition-transform group-hover:translate-x-1" data-id="element-127" />
                </Button>
                <Button variant="outline" size="lg" onClick={() => document.getElementById('services')?.scrollIntoView({
                behavior: 'smooth'
              })} className="w-full sm:w-auto" data-id="element-128">
                  View Our Services
                </Button>
              </div>

              <div className="mt-10 flex items-center justify-center lg:justify-start gap-6 text-sm text-slate-500" data-id="element-129">
                <div className="flex items-center gap-2" data-id="element-130">
                  <CheckCircle2 className="h-4 w-4 text-blue-600" data-id="element-131" />
                  <span data-id="element-132">24/7 Availability</span>
                </div>
                <div className="flex items-center gap-2" data-id="element-133">
                  <CheckCircle2 className="h-4 w-4 text-blue-600" data-id="element-134" />
                  <span data-id="element-135">Multilingual Support</span>
                </div>
              </div>
            </motion.div>
          </div>

          {/* Visual/Image Placeholder */}
          <div className="flex-1 w-full max-w-lg lg:max-w-none" data-id="element-136">
            <motion.div initial={{
            opacity: 0,
            scale: 0.95
          }} animate={{
            opacity: 1,
            scale: 1
          }} transition={{
            duration: 0.5,
            delay: 0.2
          }} className="relative" data-id="element-137">
              <div className="aspect-[4/3] rounded-2xl bg-gradient-to-br from-blue-100 to-slate-100 overflow-hidden shadow-2xl border border-white/50 relative" data-id="element-138">
                {/* Abstract UI Representation of Support Dashboard */}
                <div className="absolute inset-4 bg-white rounded-xl shadow-sm p-6 flex flex-col gap-4" data-id="element-139">
                  <div className="flex items-center justify-between border-b border-slate-100 pb-4" data-id="element-140">
                    <div className="flex items-center gap-3" data-id="element-141">
                      <div className="h-10 w-10 rounded-full bg-blue-100 flex items-center justify-center text-blue-600 font-bold" data-id="element-142">
                        JD
                      </div>
                      <div data-id="element-143">
                        <div className="h-4 w-32 bg-slate-100 rounded mb-2" data-id="element-144"></div>
                        <div className="h-3 w-20 bg-slate-50 rounded" data-id="element-145"></div>
                      </div>
                    </div>
                    <div className="h-8 w-24 bg-green-50 text-green-600 rounded-full flex items-center justify-center text-xs font-medium" data-id="element-146">
                      Active Now
                    </div>
                  </div>
                  <div className="space-y-3" data-id="element-147">
                    <div className="h-16 bg-slate-50 rounded-lg p-3 w-3/4" data-id="element-148"></div>
                    <div className="h-16 bg-blue-50 rounded-lg p-3 w-3/4 ml-auto" data-id="element-149"></div>
                    <div className="h-16 bg-slate-50 rounded-lg p-3 w-3/4" data-id="element-150"></div>
                  </div>
                  <div className="mt-auto pt-4 border-t border-slate-100 flex gap-3" data-id="element-151">
                    <div className="h-10 flex-1 bg-slate-50 rounded-lg" data-id="element-152"></div>
                    <div className="h-10 w-10 bg-blue-600 rounded-lg" data-id="element-153"></div>
                  </div>
                </div>
              </div>

              {/* Floating Badge */}
              <div className="absolute -bottom-6 -left-6 bg-white p-4 rounded-xl shadow-xl border border-slate-100 flex items-center gap-4" data-id="element-154">
                <div className="flex -space-x-3" data-id="element-155">
                  {[1, 2, 3].map(i => <div key={i} className="h-10 w-10 rounded-full border-2 border-white bg-slate-200 flex items-center justify-center text-xs text-slate-500 font-medium" data-id="element-156">
                      Ag
                    </div>)}
                </div>
                <div data-id="element-157">
                  <p className="text-sm font-bold text-slate-900" data-id="element-158">10+ Agents</p>
                  <p className="text-xs text-slate-500" data-id="element-159">Ready to help</p>
                </div>
              </div>
            </motion.div>
          </div>
        </div>
      </div>
    </section>;
}